import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";

const fallbackCopy = (text) => {
  const ta = document.createElement("textarea");
  ta.value = text;
  document.body.appendChild(ta);
  ta.select();
  document.execCommand("copy");
  ta.remove();
};

export const CopyButton = ({ text, testId }) => {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(text); } catch { fallbackCopy(text); }
    setDone(true);
    toast.success("Copied to clipboard");
    setTimeout(() => setDone(false), 1800);
  };
  return (
    <button type="button" onClick={copy} className="inline-flex shrink-0 items-center gap-1 rounded-full border border-white/10 px-2.5 py-1 text-[11px] font-semibold text-slate-200 transition-colors hover:border-cyan-400/50 hover:text-white" data-testid={testId}>
      {done ? <Check className="h-3 w-3 text-emerald-300" aria-hidden="true" /> : <Copy className="h-3 w-3" aria-hidden="true" />} {done ? "Copied" : "Copy"}
    </button>
  );
};

export const EvidenceChip = ({ type, citation, date, url, testId }) => {
  const sourced = type === "sourced_fact";
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-1.5 text-[10px]" data-testid={testId}>
      <span className={`rounded-full border px-2 py-0.5 font-semibold ${sourced ? "border-emerald-400/40 bg-emerald-500/10 text-emerald-300" : "border-amber-400/40 bg-amber-500/10 text-amber-300"}`}>
        {sourced ? "Sourced Fact" : "Method Estimate"}
      </span>
      {citation && (url
        ? <a href={url} target="_blank" rel="noopener noreferrer" className="min-w-0 truncate text-slate-400 underline-offset-2 hover:text-cyan-300 hover:underline">{citation}</a>
        : <span className="min-w-0 truncate text-slate-500">{citation}</span>)}
      {date && <span className="text-slate-500">· {date}</span>}
    </div>
  );
};
